/**
 * DUNAMIS WEAR — Luxury Scroll Reveals
 * Waits for intro dismiss, then runs hero + scroll animations
 */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('js')) return;

  var animationsEnabled = root.getAttribute('data-animations') === 'true';
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll() {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
    document.querySelectorAll('[data-section-reveal]').forEach(function (el) {
      el.classList.add('is-section-visible');
    });
    document.querySelectorAll('[data-reveal-stagger]').forEach(function (el) {
      el.classList.add('is-stagger-done');
    });
    document.querySelectorAll('.hero-editorial').forEach(function (el) {
      el.classList.add('hero-editorial--loaded');
    });
  }

  if (!animationsEnabled || prefersReducedMotion) {
    showAll();
    return;
  }

  function setupStagger() {
    document.querySelectorAll('[data-reveal-stagger]').forEach(function (parent) {
      var items = parent.querySelectorAll('[data-reveal-stagger-item]');
      if (!items.length) items = parent.children;

      Array.prototype.forEach.call(items, function (child, index) {
        if (!child.hasAttribute('data-reveal')) {
          if (child.classList.contains('product-card')) {
            child.setAttribute('data-reveal', 'scale');
          } else if (child.classList.contains('video-gallery__item')) {
            child.setAttribute('data-reveal', 'scale');
          } else {
            child.setAttribute('data-reveal', 'fade');
          }
        }
        if (!child.hasAttribute('data-reveal-delay')) {
          child.setAttribute('data-reveal-delay', String(Math.min(index + 1, 12)));
        }
      });
    });
  }

  function resetReveals(heroContent) {
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (heroContent && heroContent.contains(el)) return;
      el.classList.remove('is-visible');
    });
    document.querySelectorAll('[data-section-reveal]').forEach(function (el) {
      el.classList.remove('is-section-visible');
    });
    document.querySelectorAll('[data-reveal-stagger]').forEach(function (el) {
      el.classList.remove('is-stagger-done');
    });
  }

  function startHeroSequence(heroContent, hero) {
    if (!heroContent) return;

    var heroItems = heroContent.querySelectorAll('[data-reveal]');
    heroItems.forEach(function (el) {
      el.classList.remove('is-visible');
    });

    window.setTimeout(function () {
      if (hero) hero.classList.add('hero-editorial--loaded');
    }, 150);

    heroItems.forEach(function (el) {
      var delay = parseInt(el.getAttribute('data-reveal-delay') || '1', 10);
      window.setTimeout(function () {
        el.classList.add('is-visible');
      }, 350 + delay * 200);
    });
  }

  function initMotion() {
    setupStagger();

    var heroContent = document.querySelector('.hero-editorial__content');
    var hero = document.querySelector('.hero-editorial');

    resetReveals(heroContent);
    startHeroSequence(heroContent, hero);

    var revealElements = document.querySelectorAll('[data-reveal]');

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-section-visible');
            sectionObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -8% 0px' }
    );

    document.querySelectorAll('[data-section-reveal]').forEach(function (section) {
      sectionObserver.observe(section);
    });

    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);

          var staggerParent = entry.target.closest('[data-reveal-stagger]');
          if (staggerParent) {
            window.setTimeout(function () {
              staggerParent.classList.add('is-stagger-done');
            }, 1000);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    revealElements.forEach(function (el) {
      if (heroContent && heroContent.contains(el)) return;
      revealObserver.observe(el);
    });

    /* Sem parallax no hero — transform no container congela o vídeo no desktop */

    /* Fallback longo — só se algo falhar no observer */
    window.setTimeout(showAll, 45000);
  }

  function introIsActive() {
    var intro = document.getElementById('IntroVideo');
    if (intro) return true;
    var section = document.getElementById('shopify-section-intro-video');
    if (!section) return false;
    if (section.classList.contains('intro-video-section--dismissed')) return false;
    if (section.style.display === 'none') return false;
    return section.querySelector('.intro-video') != null;
  }

  function waitForIntroDone(callback) {
    if (!introIsActive()) {
      callback();
      return;
    }

    var done = false;
    function finish() {
      if (done) return;
      done = true;
      window.setTimeout(callback, 500);
    }

    window.addEventListener('dunamis:intro-dismissed', finish, { once: true });

    var section = document.getElementById('shopify-section-intro-video');
    if (section) {
      var observer = new MutationObserver(function () {
        if (!introIsActive()) {
          observer.disconnect();
          finish();
        }
      });
      observer.observe(section, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    window.setTimeout(finish, 12000);
  }

  waitForIntroDone(initMotion);
})();
